exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-screen {\n  position: fixed;\n  top:0;\n  bottom:0;\n  left:0;\n  right:0;\n  z-index: 2222;\n}\n.mask {\n  position: absolute;\n  top:0;\n  bottom:0;\n  left:0;\n  right:0;\n  background-color: #f2f2f2;\n  opacity: .6;\n}\n.spinner {\n  position: absolute;\n  top:0;\n  bottom:0;\n  left:0;\n  right:0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 433
// module chunks = 0